import {Injectable} from "@angular/core";
import {FormControl} from "@angular/forms";

@Injectable()
export class PointOfSaleValidatorService {

    private errors:any={};

    public validate(posForm) {
        this.errors = {};
        let isValid = true;
        if(!this.validateForm(posForm)){
            isValid=false;
        }
        return {valid:isValid, errors:this.errors};
    }

    public validateMeetingType(c: FormControl) {
        if(!!c.value.meetingType && c.value.destinationType == 'AIRPORT' && (!c.value.enabledCountry
                || (c.value.enabledCountry
                    && ['CALL','AIRPORT_SHUTTLE','RENTAL_SHUTTLE'].some((id) => id == c.value.meetingType)))){
            return null;
        }else if(!!c.value.meetingType && c.value.meetingType=='COUNTER' && c.value.destinationType == 'CITY' && !!c.value.street){
            return null;
        }
        return {valid: false};
    }

    public validatePickupIndications(c: FormControl){
        let error = {};
        let isValid = true;

       if(c.value.enabledCountry){
            if(c.value.meetingType == 'RENTAL_SHUTTLE'){
                return (!!c.value.pickupIndications.meetingPlatforms && c.value.pickupIndications.meetingPlatforms.length>0)?null:{platform:true}
            } else if(c.value.meetingType == 'AIRPORT_SHUTTLE'){

                if(!c.value.pickupIndications.meetingPoint){
                    error['meetingPoint']='required';
                    isValid=false;
                } else if(c.value.pickupIndications.meetingPoint.length >50){
                    error['meetingPoint']='length';
                    isValid=false;
                }
                if(!c.value.pickupIndications.shuttleName){
                    error['shuttleName']=true;
                    isValid=false;
                }
                return isValid?null:error;
            }else if(c.value.meetingType == 'CALL'){
                if(!c.value.pickupIndications.meetingPoint){
                    error['meetingPoint']='required';
                    isValid=false;
                }else if(c.value.pickupIndications.meetingPoint.length >50){
                    error['meetingPoint']='length';
                    isValid=false;
                }
                return isValid?null:error;
            }
            return null;
        }
    }

    public validateMiamiPickupIndications(c: FormControl){
        let error = {};
        let phoneExpectedLength = 15;
        let isValid = true;
        let phoneRequired = c.value.phoneRequired;
        let phoneOptional = c.value.phoneOptional;
        let miamiAirportPositions = c.value.miamiAirportPositions;

        if(!phoneRequired || phoneRequired === "" || phoneRequired.trim() === '+1') {
            error['phoneRequiredMissing']={required:true};

        } else if(phoneRequired && phoneRequired.split('_').join('').length < phoneExpectedLength) {
            error['phoneRequiredDigit']={required:true};
        }

        if(phoneOptional && phoneOptional.split('_').join('').length < phoneExpectedLength) {
            error['phoneOptionalDigit']= {required:true};
        }

            if(miamiAirportPositions && miamiAirportPositions.length === 0) {
                error['miamiAirportPositionsRequired']= {required: true};
            }

        isValid = Object.keys(error).length === 0;

        return isValid ? null : error;
    }

    public validateCancunPickupIndications(c: FormControl){
        let error = {};
        let phoneExpectedLength = 15;
        let isValid = true;
        let phoneRequired = c.value.phoneRequired;
        let phoneOptional = c.value.phoneOptional;
        let cancunAirportPositions = c.value.cancunAirportPositions;

        if(!phoneRequired || phoneRequired === "" || phoneRequired.trim() === '+52') {
            error['phoneRequiredMissing']={required:true};

        } else if(phoneRequired && phoneRequired.split('_').join('').length < phoneExpectedLength) {
            error['phoneRequiredDigit']={required:true};
        }

        if(phoneOptional && phoneOptional.split('_').join('').length < phoneExpectedLength) {
            error['phoneOptionalDigit']= {required:true};
        }

        if(cancunAirportPositions && cancunAirportPositions.hasCounter && cancunAirportPositions.counters.length == 0){
            error['positionsCounterRequired']= {required: true};
        }

        isValid = Object.keys(error).length === 0;

        return isValid ? null : error;
    }

    public validateOrlandoPickupIndications(c: FormControl){
        let error = {};
        let phoneExpectedLength = 15;
        let isValid = true;
        let phoneRequired = c.value.phoneRequired;
        let phoneOptional = c.value.phoneOptional;
        let orlandoAirportPositions = c.value.orlandoAirportPositions;

        if(!phoneRequired || phoneRequired === "" || phoneRequired.trim() === '+1') {
            error['phoneRequiredMissing']={required:true};

        } else if(phoneRequired && phoneRequired.split('_').join('').length < phoneExpectedLength) {
            error['phoneRequiredDigit']={required:true};
        }

        if(phoneOptional && phoneOptional.split('_').join('').length < phoneExpectedLength) {
            error['phoneOptionalDigit']= {required:true};
        }

        if((orlandoAirportPositions && orlandoAirportPositions.length === 0) || !orlandoAirportPositions) {
            error['meetingPointsRequired']= {required: true};
        }

        isValid = Object.keys(error).length === 0;

        return isValid ? null : error;
    }

    public notNullOrUndefined(c: FormControl){
        return !!c.value && !!c.value.destination && !!c.value.destinationType;
    }

    public validateLocation(c: FormControl){
        return !!c.value && !!c.value.destination && !!c.value.destinationType &&
        (c.value.destinationType!='CITY' || c.value.destinationType=='CITY' && !!c.value.street)? null : {
            valid: false
        };
    }

    public validatePaymentMethods(c: FormControl) {
        const payInCashAllowed: boolean = !!c.value.payInCash;
        const creditCardAllowed: boolean = !!c.value.paymentMethods && Object.keys(c.value.paymentMethods).some((k) => !!c.value.paymentMethods[k]);
        return creditCardAllowed || payInCashAllowed ? null : { valid: false };
    }


    private validateForm(form) : boolean{
        if(form.valid){
            return true;
        } else {
            this.reportErrors(form);
            return false;
        }
    }

    private reportErrors(form: any) {
        Object.keys(form.controls).forEach((key) => {
            if(!!form.controls[key].errors){
                this.errors[key] = form.controls[key].errors;
            }
        })
    }

    private reportError(key, obj) {
        this.errors[key]=obj;
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/edit/point-of-sale-validator.service.ts